'use server';

export const checkVersion = async () => {
  const version = process.env.VERSION || '';
  return version;
};
